import React from "react";

const joinClassNames = (...values) => values.filter(Boolean).join(" ");

const ClearPageLayout = ({ children, className, contentClassName }) => {
  return (
    <div className={joinClassNames("clear-page-layout", className)}>
      <div className={joinClassNames("clear-page-layout__content", contentClassName)}>
        {children}
      </div>
    </div>
  );
};

export default ClearPageLayout;
